import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";

import AdminLayout from "@/components/layout/AdminLayout";
import DocsLayout from "@/components/layout/DocsLayout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Operators from "@/pages/Operators";
import Providers from "@/pages/Providers";
import Games from "@/pages/Games";
import WalletLedger from "@/pages/WalletLedger";
import OperatorCredits from "@/pages/OperatorCredits";
import Sandbox from "@/pages/Sandbox";
import Reconciliation from "@/pages/Reconciliation";
import Settlement from "@/pages/Settlement";
import Webhooks from "@/pages/Webhooks";
import Audit from "@/pages/Audit";
import Monitoring from "@/pages/Monitoring";
import Sessions from "@/pages/Sessions";
import Ekyc from "@/pages/Ekyc";
import Media from "@/pages/Media";
import DocsHome from "@/pages/docs/DocsHome";
import DocPage from "@/pages/docs/DocPage";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#0f0f10", color: "#f4f4f5", border: "1px solid #2a2a2d" } }}/>
        <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route element={<AdminLayout/>}>
            <Route path="/" element={<Navigate to="/dashboard" replace/>}/>
            <Route path="/dashboard" element={<Dashboard/>}/>
            <Route path="/operators" element={<Operators/>}/>
            <Route path="/providers" element={<Providers/>}/>
            <Route path="/games" element={<Games/>}/>
            <Route path="/wallet" element={<WalletLedger/>}/>
            <Route path="/operator-credits" element={<OperatorCredits/>}/>
            <Route path="/sessions" element={<Sessions/>}/>
            <Route path="/sandbox" element={<Sandbox/>}/>
            <Route path="/reconciliation" element={<Reconciliation/>}/>
            <Route path="/settlement" element={<Settlement/>}/>
            <Route path="/webhooks" element={<Webhooks/>}/>
            <Route path="/audit" element={<Audit/>}/>
            <Route path="/monitoring" element={<Monitoring/>}/>
            <Route path="/ekyc" element={<Ekyc/>}/>
            <Route path="/media" element={<Media/>}/>
          </Route>
          <Route path="/docs" element={<DocsLayout/>}>
            <Route index element={<DocsHome/>}/>
            <Route path=":slug" element={<DocPage/>}/>
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
